import { createKubbApiClient } from '../kubb-api-client';
export * from '../kubb-api-client';

export const axiosClient = createKubbApiClient('users-authz');

export default axiosClient;
